'use client';
import React, { useState } from 'react';

import { SvgIcon } from '@/components/SvgIcon';

import { Modal } from '@/components/atoms/Modal';
import { SECTION_NAMES } from '@/integrations/trackingScripts/constants';

import iconZoomInSrc from '~/svg/IconZoomIn.svg';

export interface ImageBlockProps {
  isExpandable: boolean;
  image: React.ReactNode;
  expandedImage?: React.ReactNode;
}

export const ImageBlock = ({
  isExpandable,
  image,
  expandedImage = image,
}: ImageBlockProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div data-tracker-component='image-block' className='w-full'>
      <div className='shadow-tiny rounded dark:shadow-none relative mx-auto'>
        {image}
        {isExpandable && (
          <span className='hover:bg-gray-500 absolute left-6 top-6 flex h-12 w-12 cursor-pointer items-center justify-center rounded-full bg-gray-400 transition'>
            <SvgIcon
              src={iconZoomInSrc}
              asImg
              onClick={() => setIsOpen(true)}
            />
          </span>
        )}
      </div>
      <Modal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        hasClose={false}
        classNames={{
          modal:
            'bg-transperant border-none shadow-none w-full animate-zoom-in md:w-3/4',
        }}
        data-tracker-section={SECTION_NAMES.IMAGE_BLOCK}
      >
        {expandedImage}
      </Modal>
    </div>
  );
};
